import { Button } from "@/components/shared/buttons/Button";
import AddIcon from "@mui/icons-material/Add";
import { useDialogs } from "@toolpad/core";
import { NewTopicDialog } from "./dialogs/NewTopicDialog";

/**
 * Button to add a new topic.
 */
export const AddTopicButton = () => {
    const dialogs = useDialogs();

    const handleClick = async () => {
        await dialogs.open(NewTopicDialog);
    };

    return (
        <Button
            type="button"
            variant="contained"
            color="secondary"
            disableElevation
            sx={{ borderRadius: 22 }}
            startIcon={<AddIcon />}
            onClick={handleClick}
        >
            Create
        </Button>
    );
};
